import React from "react"
import macLogo from "../styles/img/logo.png"

/**
 * Spinner de carga con el logo de Hospitales MAC.
 *
 * Props:
 *   visible {boolean}  — controla si el overlay se muestra.
 *   message {string}   — texto opcional debajo del logo (default: "Cargando...").
 */
const MacSpinner = ({ visible, message = "Cargando..." }) => {
    if (!visible) return null

    return (
        <div className="mac-spinner-overlay" role="status" aria-live="polite">
            <div className="mac-spinner-card">
                <div className="mac-spinner-ring">
                    <div className="mac-spinner-ring__circle"/>
                    <img
                        src={macLogo}
                        alt="Hospitales MAC"
                        className="mac-spinner-logo"
                    />
                </div>
                <p className="mac-spinner-message">{message}</p>
            </div>
        </div>
    )
}

export default MacSpinner
